import React from "react";
import DOMPurify from "dompurify";
import { resolveImage } from "../../../lib/cms";

function Value({ f, v }) {
  if (v === undefined || v === null || v === "") return <span className="italic text-stonegrey">— empty —</span>;
  if (f.type === "image") return <img src={resolveImage(v)} alt="" className="h-20 w-28 rounded-lg object-cover" />;
  if (f.type === "richtext") return <div className="prose-article !text-sm" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(v) }} />;
  if (f.type === "attachments") return <span>{(v || []).map((a) => a.name).join(", ") || "None"}</span>;
  return <span className="whitespace-pre-wrap">{String(v)}</span>;
}

const same = (a, b) => JSON.stringify(a ?? "") === JSON.stringify(b ?? "");

function FieldRows({ fields, left, right, prefix }) {
  return fields.map((f) => {
    const changed = !same(left?.[f.k], right?.[f.k]);
    return (
      <div key={`${prefix}-${f.k}`} className={`grid grid-cols-2 gap-4 rounded-lg px-3 py-2.5 ${changed ? "bg-gold/15 ring-1 ring-gold/40" : ""}`}
        data-testid={`diff-row-${prefix}-${f.k}${changed ? "-changed" : ""}`}>
        <div className="col-span-2 font-sans text-[10px] font-semibold uppercase tracking-widest text-stonegrey">
          {f.label}{changed && <span className="ml-2 text-gold-deep">Changed</span>}
        </div>
        <div className="min-w-0 font-sans text-sm text-charcoal"><Value f={f} v={left?.[f.k]} /></div>
        <div className="min-w-0 font-sans text-sm text-charcoal"><Value f={f} v={right?.[f.k]} /></div>
      </div>
    );
  });
}

export default function VersionDiff({ schema, left, right }) {
  if (schema?.items) {
    const n = Math.max(left.items?.length || 0, right.items?.length || 0);
    return (
      <div className="space-y-5">
        {Array.from({ length: n }).map((_, i) => {
          const a = left.items?.[i];
          const b = right.items?.[i];
          return (
            <div key={i} className="rounded-xl border border-sapphire-deep/10 p-3">
              <p className="mb-2 font-display text-base font-semibold text-sapphire-deep">
                {schema.items.label} {i + 1}
                {!a && <span className="ml-2 font-sans text-xs text-emerald">Added since</span>}
                {!b && <span className="ml-2 font-sans text-xs text-garnet">Removed since</span>}
              </p>
              <FieldRows fields={schema.items.fields} left={a} right={b} prefix={i} />
            </div>
          );
        })}
      </div>
    );
  }
  return <div className="space-y-2"><FieldRows fields={schema?.fields || []} left={left} right={right} prefix="f" /></div>;
}
